const menuToggle = document.querySelector('#menu-toggle');
// const header = document.querySelector('#header');
const body = document.querySelector('body');
const navigation = document.querySelector('#mainNavigation');

const activateToggle = () => {
  menuToggle.addEventListener('click', () => {
    navigation.classList.toggle('show');
    // header.classList.toggle('visible');
    body.classList.toggle('mobile-menu-visible');
    menuToggle.classList.toggle('active');
    menuToggle.classList.toggle('not-active');
  });

  // If someone desides to resize window while mobile menu is active it will hide
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1200) {
      navigation.classList.remove('show');
    }
  });
};

export default activateToggle;
